import React from "react";
import "./App.css";
import Hero from "./components/Hero";
// import About from "./components/About";
import Chart from "./components/Tokenomics";
import Projects from "./components/Projects";
import Roadmap from "./components/Roadmap";
import Security from "./components/Security";
import Partners from "./components/Partners";
import Faqs from "./components/Faqs";
import Footer from "./components/Footer";
import DigiPool from "./components/DigiPool";


function App() {
  return (
    <>
      <Hero />
      <DigiPool />

      {/* <div className="bg-gradient-to-tl from-gray-500 via-green-100/50 to-gray-400 ">
        <div className=" dark:bg-black">
          <About />
        </div>
      </div> */}
      <div className=" bg-gradient-to-tr from-gray-400 via-green-100/50 to-gray-500">
        <div className=" dark:bg-black">
          <Chart />
        </div>
      </div>
      <div className="bg-gradient-to-tl from-gray-500 via-green-100/50 to-gray-400 ">
        <div className=" dark:bg-black pt-[4rem] pb-8 ">
          <Projects />
        </div>
      </div>
      <div className="bg-gradient-to-tr from-gray-400 via-green-100/50 to-gray-500 ">
        <div className=" dark:bg-black">
          <Roadmap />
        </div>
      </div>
      <div className="bg-gradient-to-tl from-gray-500 via-green-100/50 to-gray-400 ">
        <div className=" dark:bg-black">
          <Security />
        </div>
      </div>
      <div className="bg-gradient-to-tr from-gray-400 via-green-100/50 to-gray-500 ">
        <div className=" dark:bg-black">
   
          <Partners />
        </div>
      </div>
      <div className="bg-gradient-to-tl from-gray-500 via-green-100/50 to-gray-400 ">
        <div className=" dark:bg-black">
          <Faqs />
        </div>
      </div>
      <div className="bg-gradient-to-tr from-gray-300 via-green-100/50 to-gray-400 ">
        <div className=" dark:bg-black">
      <Footer />
        </div>
      </div>
     
    </>
  );
}

export default App;
